import { render } from "./ThirteenSection.vue?vue&type=template&id=9c2017e4&scoped=true"
import script from "./ThirteenSection.vue?vue&type=script&lang=js"
export * from "./ThirteenSection.vue?vue&type=script&lang=js"

import "./ThirteenSection.vue?vue&type=style&index=0&id=9c2017e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c2017e4"]])

export default __exports__